
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/something-new",
      function () {
        return require("private-next-pages/something-new/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/something-new"])
      });
    }
  